export default "__VITE_ASSET__BWI5XOAV__"